import { List, Modal } from 'antd'
import { IDataByDayItem } from '../../model/selectors'
import React, { memo, useCallback } from 'react'
import { TaskIcon } from './styles'
import { Link } from 'react-router-dom'
import HeaderWithDateTemplate from '../header-with-date-template/header-with-date-template'
import HeaderWithTextTemplate from '../header-with-text-template/header-with-text-template'

interface TaskDetailModalProps {
  isOpen: boolean
  onCancel: ((e: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
  data: IDataByDayItem[]
}

export const TaskDetailModal: React.FC<TaskDetailModalProps> = memo(
  (props: TaskDetailModalProps) => {
    const { isOpen, onCancel, data } = props

    const getUrl = (card_type?: string) => {
      if (card_type === 'case') return 'order'
      if (card_type === 'claim_work') return 'claim-work'
      return card_type
    }

    const actualId = useCallback(item => {
      return item.card_type === 'measurements' ? item.card_id : item.case_id
    }, [])

    const actualNumber = useCallback(item => {
      return item.card_type === 'measurements' ? item.case_id : item.card_id
    }, [])

    return (
      <Modal footer={null} open={isOpen} onCancel={onCancel} destroyOnHidden={true}>
        <List
          itemLayout="horizontal"
          style={{ maxHeight: '600px', overflowY: 'scroll' }}
          dataSource={data}
          renderItem={(item: IDataByDayItem) => (
            <List.Item key={item.id} style={{ flexDirection: 'column', alignItems: 'start' }}>
              <HeaderWithTextTemplate
                title={
                  <>
                    <TaskIcon $stage={item.stage} /> Задача №{item.id}: {item.type}
                  </>
                }
              />
              {Boolean(item?.brand) && (
                <HeaderWithTextTemplate title={'Бренд:'} text={item?.brand} />
              )}
              {Boolean(item?.order_attribute) && (
                <HeaderWithTextTemplate title={'Признак заказа:'} text={item?.order_attribute} />
              )}
              {Boolean(item?.production_number) && (
                <HeaderWithTextTemplate
                  title={'Номер произ.заказа:'}
                  text={item.production_number}
                />
              )}
              {Boolean(item?.name) && (
                <HeaderWithTextTemplate title={'ФИО клиента:'} text={item.name} />
              )}
              {Boolean(item?.address) && (
                <HeaderWithTextTemplate title={'Адрес:'} text={item?.address} />
              )}
              {Boolean(item?.responsible) && (
                <HeaderWithTextTemplate
                  title={'Ответственные:'}
                  text={item?.responsible?.join(', ')}
                />
              )}
              {Boolean(item?.task) && (
                <HeaderWithTextTemplate title={'Комментарий:'} text={item?.task} />
              )}
              <HeaderWithDateTemplate date={item.deadline} title={'Крайний срок:'} />
              <HeaderWithTextTemplate
                title={
                  <Link to={`/${getUrl(item.card_type)}/${actualId(item)}`}>
                    Перейти в запись №{actualNumber(item)}
                  </Link>
                }
              />
            </List.Item>
          )}
        />
      </Modal>
    )
  },
)

TaskDetailModal.displayName = 'TaskDetailModal'
